export const BOOK_STRIP_ROW = "scrollbar-hide flex h-11 flex-shrink-0 items-center gap-1 overflow-x-auto border-b border-surface-line px-3 md:h-8";
